<template>
  <div id="expression" style="height: 500px"></div>
</template>

<script>
import axios from "axios";

export default {
  mounted() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/scATAC/searchPie.php", {
        params: { datasetId: this.$route.query.datasetId },
      })
      .then((response) => {
        this.plotBar(response.data);
      });
  },
  methods: {
    plotBar(data) {
      let myChart = this.$echarts.init(document.getElementById("expression"));
      myChart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          //   orient: "align",
          x: "top",
          y: "right",
          left: "top",
        },
        series: [
          {
            name: "Number of cell group by perturbations",
            type: "pie",
            radius: "70%",
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
      //随着窗口的拖动,图自适应窗口的大小
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>

<style></style>
